import React, { Component } from "react"
import PropTypes from "prop-types"
import { Link, withRouter } from "react-router-dom"
import gridView from "../../../assets/img/grid-view.png"
import engagementView from "../../../assets/img/engagement-view.png"
import {
    Col,
    Row,
    Card,
  } from "reactstrap"
class ProjectFilterMenu extends Component {
    constructor(props) {
      super(props)
    
      this.state = {
      }
    }
    render() {
      const { location } = this.props;
        return (
          <React.Fragment>
                     <div className="">
                        <div
                            className="btn-group rl-group-btn"
                            role="group"
                        >
                            <Link to="/pre-construction/project/lead">
                            <button
                            type="button"
                            className={`btn btn-outline-secondary w-xs  bt-filter-v2 ${location.pathname === "/pre-construction/project/lead" ? "active" : ""}`}
                            >
                             <span className="d-flex align-items-center gap-2">
                            Grid View
                             <img src={gridView} style={{ height: 16 }} />
                             </span>
                            </button>
                            </Link>
                            <Link to="/pre-construction/project/lead/worksheet-pending">
                            <button
                            type="button"
                            className={`btn btn-outline-secondary w-xs  bt-filter-v2 ${location.pathname === "/pre-construction/project/lead/worksheet-pending" ? "active" : ""}`}
                            >
                           
                            <span className="d-flex align-items-center gap-2">
                             Pending Worksheets
                             <img src={engagementView} style={{ height: 16 }} />
                             </span>
                            </button>
                            </Link>
                            {/* <Link to="/pre-construction/project/lead/worksheet-submitted">
                            <button
                            type="button"
                            className={`btn btn-outline-secondary w-xs ${location.pathname === "/pre-construction/project/lead/worksheet-submitted" ? "active" : ""}`}
                            >
                            <img src={engagementView} />
                            <br/>
                             Submitted Worksheets
                            
                            </button>
                            </Link>                          */}
                        
                        </div>
                        </div>     
            </React.Fragment>
        )
    }
}
ProjectFilterMenu.propTypes = {


  location: PropTypes.any
}
export default withRouter(ProjectFilterMenu)